import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { finalize, Observable } from "rxjs";
import { DataService } from "../../core/core-services/services/dataservices/data.service";
import { LoadingService } from "src/app/components/loading/loading.service";

@Injectable()
export class ProfileResolver  {
  constructor(private dataService: DataService, private loadingService: LoadingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    // this.loadingService.show();
    return this.dataService.get({ url: "v1/user", isLoader: false }).pipe(
      finalize(() => {
        // this.loadingService.hide()
      })
    );
  }
}
